export default __webpack_public_path__ + "static/media/PumaxBruna_06_1418_R1.123a861f.png";